export const ENABLE_MFA = "ENABLE_MFA";
export const ENABLE_MFA_SUCCESS = "ENABLE_MFA_SUCCESS";
export const ENABLE_MFA_ERROR = "ENABLE_MFA_ERROR";

export const DISABLE_MFA = "DISABLE_MFA";
export const DISABLE_MFA_SUCCESS = "DISABLE_MFA_SUCCESS";
export const DISABLE_MFA_ERROR = "DISABLE_MFA_ERROR";

export const INIT_MFA = "INIT_MFA";
